var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWarning = function SvgWarning(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6676 12.2431L10.0155 1.21754C9.10744 -0.404769 6.89378 -0.406925 5.98447 1.21754L0.332715 12.2431C-0.595598 13.9008 0.528309 16 2.34778 16H13.652C15.47 16 16.5959 13.9025 15.6676 12.2431ZM8 14.0103C7.48319 14.0103 7.0625 13.5639 7.0625 13.0154C7.0625 12.467 7.48319 12.0206 8 12.0206C8.51681 12.0206 8.9375 12.467 8.9375 13.0154C8.9375 13.5639 8.51681 14.0103 8 14.0103ZM8.9375 10.0309C8.9375 10.5793 8.51681 11.0257 8 11.0257C7.48319 11.0257 7.0625 10.5793 7.0625 10.0309V5.05659C7.0625 4.50816 7.48319 4.06173 8 4.06173C8.51681 4.06173 8.9375 4.50816 8.9375 5.05659V10.0309Z",
    fill: "#D7B037"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "warning.8cbdb62eaf0875ac171a6bff5d551777.svg";